import { css } from '@emotion/react';
import { theme } from 'global';

// ─── Shared layout ───────────────────────────────────────────────────────────

export const container = css`
  min-height: calc(100vh - 64px);
  background: white;
  display: flex;
  flex-direction: column;
`;

// ─── Loading / Eligible view ─────────────────────────────────────────────────

export const statusContainer = css`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

export const statusContent = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 20px;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    padding-bottom: 80px;
  }
`;

export const pocketWrapper = css`
  width: 64px;
  height: 64px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
`;

export const pocketIcon = css`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const statusMessage = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  text-align: center;
  max-width: 343px;
  margin: 0;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    font-family: ${theme.fonts.heading3.family};
    font-weight: ${theme.fontWeights.medium};
    font-size: ${theme.fontSizes.heading3};
    line-height: ${theme.lineHeights.heading3};
    letter-spacing: ${theme.letterSpacings.heading3};
    max-width: 600px;
  }
`;

// ─── Not-eligible view ───────────────────────────────────────────────────────

export const notEligibleContent = css`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    align-items: flex-start;
  }
`;

export const notEligibleCard = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  max-width: 744px;
  background: white;
  border-radius: 12px;
  padding: 0;

  @media screen and (min-width: ${theme.breaks.sm}px) {
    padding: 24px;
  }
`;

export const notEligibleTextGroup = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;
  width: 100%;
`;

export const notEligibleTitle = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.secondary};
  text-align: center;
  margin: 0;
`;

export const notEligibleBody = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  text-align: center;
  margin: 0;
`;

export const notEligibleButtonWrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const primaryButton = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.muted};
  text-align: center;
`;

export const contactText = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.neutral[600]};
  text-align: center;
  margin: 0;
`;

export const contactLink = css`
  font-feature-settings:
    'liga' off,
    'clig' off;
  color: ${theme.colors.primary.medium};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
